<template>
  <v-row v-if="subject" no-gutters class="" id="tela-agenda">
    <v-col cols="12">
      <div class="titulo-agenda">
        <br />
        <img v-if="isHomeSchool"
          src="@/assets/icone_casa_home_school.svg"
          style="width: 42px; margin-top: -6px;"
        />
        <img
          v-else
          src="@/assets_aluno/icone_chapeu_formatura.svg"
          style="height: 42px;"
          alt=""
        /><br />
        Marcar aula<br />
        particular de<br />
        <span>{{ subject.name }} </span><br />
        <span v-if="!isHomeSchool">no cem</span>
        <span v-else>em casa</span>
        <br /><br />
      </div>
    </v-col>
    <SubjectProfessorsDialog v-if="subject" :subjectId="subject.id" />

    <CalendarTimes
      :selected-professor="selectedProfessor"
      :affiliate-id="affiliateId"
      :subject="subject"
      :professors="professorsBySubject"
      place="presential"
    />
  </v-row>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import SubjectProfessorsDialog from "@/components/dialogs/SubjectProfessorsDialog";
import CalendarTimes from "./CalendarTimes";

export default {
  components: {
    SubjectProfessorsDialog,
    CalendarTimes
  },
  props: {
    subject: Object,
    affiliateId: Number
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("professorsModule", ["professorsBySubject"]),
    ...mapState("professorsModule", [
      "professors",
      "selectedProfessor",
      "freeTimes",
    ]),
    ...mapState([
      "isHomeSchool"
    ])
  },
  mounted() {},
  methods: {
    ...mapActions("professorsModule", ["loadFreeTimes"]),
    ...mapMutations("professorsModule", ["setSelectedProfessor"])
  }
};
</script>

<style>
.titulo-agenda {
  text-align: center;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 7px;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.7;
  padding: 16px 0;
}
.titulo-agenda span {
  font-size: 36px;
  font-weight: 900;
  color: #44ff99;
  letter-spacing: 1px;
  line-height: 1.2;
}
</style>
